import { RouteRecordRaw } from 'vue-router';
import { TrainingMatrixEditBatchPage } from '@/pages/training';

export const routeName = 'TreinamentosMatrizEditarEmLote';

export const route: RouteRecordRaw = {
  path: 'treinamentos/matriz-treinamentos/editar-em-lote',
  name: routeName,
  component: TrainingMatrixEditBatchPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Editar Matriz',
    permissions: [{ action: 'readMatrix', subject: 'Training' }],
  },
};
